import { render, staticRenderFns } from "./ModularReport.vue?vue&type=template&id=4075cecc&scoped=true&"
import script from "./ModularReport.vue?vue&type=script&lang=ts&"
export * from "./ModularReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075cecc",
  null
  
)

export default component.exports